var _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 160,
    fill: "#FDF4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 550,
    height: 158,
    fill: "none",
    stroke: "#EF8E92",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 276,
    y: 74,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "Replace with an image.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 276,
    y: 94,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "(Max resolution: 1104 x 320px)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.a6b854a1860ea6a1dbdccdc9c9c3a741.svg";
export { ForwardRef as ReactComponent };